import { render } from "./Card.vue?vue&type=template&id=2879bc0c&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=2879bc0c&scoped=true&lang=css"
import "./Card.vue?vue&type=style&index=1&id=2879bc0c&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2879bc0c"]])

export default __exports__